import { createSlice } from '@reduxjs/toolkit';
import { ref } from 'process';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: false,
    token: null,
    email: null,
    name: null,
    role: null,
    id: null,
    photo: '/assets/images/avtar/default-user.png',
    refreshToken: null,
  },
  reducers: {
    login(state, action) {
      console.log('action.payload', action.payload);
      state.isAuthenticated = true;
      state.token = action.payload.tokens.token;
      state.email = action.payload.user.email;
      state.name = action.payload.user.name;
      state.role = action.payload.user.role;
      state.id = action.payload.user.id;
      state.photo = action.payload.user.photo
        ? action.payload.user.photo
        : '/assets/images/avtar/default-user.png';
      state.refreshToken = action.payload.tokens.refreshToken;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.token = null;
      state.email = null;
      state.name = null;
      state.role = null;
      state.id = null;
      state.photo = '/assets/images/avtar/default-user.png';
      state.refreshToken = null;
    },

    setToken(state, action) {
      state.token = action.payload.token;
      if (action.payload.refreshToken) {
        state.refreshToken = action.payload.refreshToken;
      }
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
